import * as Yup from 'yup';
import { IMultiSelectControlField2 } from '../types';

export default function selectValidationSchema(
  field: IMultiSelectControlField2,
  showErrorMessage: boolean
) {
  let schema = Yup.array().nullable();
  if (field.is_mandatory) {
    schema = schema.test({
      test: (value) => {
        if (!value) {
          return false;
        }
        if (typeof value === 'string' && !(value as string).trim().length) {
          return false;
        }
        if (Array.isArray(value) && !value.length) {
          return false;
        }
        return true;
      },
      message: showErrorMessage ? 'This is required' : ''
    });
  }
  return {
    [field.name]: schema
  };
}
